import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../api/client';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ── Load user from token on mount ── */
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.getProfile()
        .then((data) => {
          setUser(data.user);
        })
        .catch(() => {
          localStorage.removeItem('token');
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  /* ── Sign up ── */
  const signUp = async (email, password, fullName, phone) => {
    try {
      const data = await api.register(email, password, fullName, phone);
      localStorage.setItem('token', data.token);
      setUser(data.user);
      return { data };
    } catch (err) {
      return { error: { message: err.message } };
    }
  };

  /* ── Sign in ── */
  const signIn = async (email, password) => {
    try {
      const data = await api.login(email, password);
      localStorage.setItem('token', data.token);
      setUser(data.user);
      return { data };
    } catch (err) {
      return { error: { message: err.message } };
    }
  };

  /* ── Sign out ── */
  const signOut = async () => {
    localStorage.removeItem('token');
    setUser(null);
    return { error: null };
  };

  /* ── Update profile ── */
  const updateProfile = async (updates) => {
    try {
      const data = await api.updateProfile(updates);
      setUser(data.user);
      return { data };
    } catch (err) {
      return { error: { message: err.message } };
    }
  };

  const value = {
    user,
    loading,
    signUp,
    signIn,
    signOut,
    updateProfile,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
